<crm-task-form
  *ngIf="(loading$ | async) === false"
  [isModal]="true"
  [task]="$any(task)"
  [operation]="operation"
  [canDelete]="(form$ | async)?.isEdit"
  [activeStep]="activeStep"
  [permissions]="taskEditPermissions"
  [organizations]="organizations"
  [filials]="filials"
  [units]="units"
  [priorities]="priorities"
  [directions]="directions"
  [nds]="nds"
  [banks]="banks"
  [users]="users"
  [statuses]="statuses"
  [userGroups]="userGroups"
  [schemes]="schemes"
  [currencies]="currencies"
  (changeOrganization)="changeOrganization()"
  (bankSearch)="searchBank($event)"
  (save)="saveTask($event)"
  (delete)="deleteTask()">
</crm-task-form>

<crm-spinner *ngIf="loading$ | async"></crm-spinner>
